/**
 * Facebook Login visibility:
 * - NEXT_PUBLIC_FACEBOOK_LOGIN_ENABLED=true|false → force on/off (review / kill switch)
 * - otherwise login page asks GET /auth/facebook-login-status (Meta permission approval)
 */
export { useFacebookLoginEnabled } from './useFacebookLoginEnabled';

export function isFacebookLoginEnvOverride(): boolean | null {
  const raw = process.env.NEXT_PUBLIC_FACEBOOK_LOGIN_ENABLED;
  if (raw === 'true') return true;
  if (raw === 'false') return false;
  return null;
}

/** @deprecated Use useFacebookLoginEnabled() for login UI. */
export function isFacebookLoginEnabled(): boolean {
  const override = isFacebookLoginEnvOverride();
  return override === true;
}
